export const API_LOGIN_MESSAGES = {
  0: {
    responseCode: '00',
    type: 'success',
    message: 'Inicio de sesión exitoso',
  },
  1: {
    responseCode: '01',
    type: 'warning',
    message: 'El usuario o contraseña es incorrecto',
  },
  2: {
    responseCode: '02',
    type: 'warning',
    message: 'El usuario o contraseña es incorrecto',
  },
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_STATUS_SESSION_MESSAGES = {
  3: {
    responseCode: '03',
    type: 'warning',
    message: 'Sessión finalizada',
  },
};

export const API_LOGOUT_MESSAGES = {
  0: {
    responseCode: '00',
    type: 'success',
    message: 'Sessión finalizada',
  },
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};
